import config from '../../../config';

/**
 * Saklar landing publik. Dibaca lewat helper ini saja supaya pembacaan
 * `config` tidak tersebar ke banyak komponen.
 *
 * false = seluruh landing publik mati (bukan hanya `/`), sehingga flag ini
 * bisa dipakai sebagai saklar mati darurat.
 */
export const isPublicLandingEnabled = () =>
  Boolean(config?.publicLanding?.ENABLED);
